import script from "./MDataTableRowExpand.vue?vue&type=script&setup=true&lang=js"
export * from "./MDataTableRowExpand.vue?vue&type=script&setup=true&lang=js"

import "./MDataTableRowExpand.vue?vue&type=style&index=0&id=12173015&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12173015"]])

export default __exports__